// ABOUTME: Base dialog component with a single labeled text input and a customizable actions area.
// ABOUTME: Used by AddItemDialog and any other dialog that needs a single text field.
import { type ReactNode } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

interface Props {
  open: boolean
  onClose?: () => void
  title: string
  label: string
  value: string
  onChange: (value: string) => void
  onSubmit?: () => void
  error?: string | null
  disabled?: boolean
  disableEscapeKeyDown?: boolean
  children: ReactNode
}

export function InputDialog({
  open, onClose, title, label, value, onChange, onSubmit, error, disabled, disableEscapeKeyDown, children,
}: Props) {
  return (
    <Dialog open={open} fullWidth maxWidth="xs" onClose={onClose} disableEscapeKeyDown={disableEscapeKeyDown}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && onSubmit) onSubmit() }}
          error={!!error}
          helperText={error}
          disabled={disabled}
        />
      </DialogContent>
      <DialogActions>
        {children}
      </DialogActions>
    </Dialog>
  )
}
